<template>
    <label
        class="flex flex-col"
        :class="disabled ? ['opacity-75'] : []"
        :for="name"
    >
        <p class="font-medium text-sm sm:text-base">
            <slot></slot>
        </p>
        <input
            class="w-full h-9.2 px-2 text-sm focus:outline-none focus:border-2 focus:border-light-blue border-2 border-brown"
            :class="classes"
            :type="type"
            :name="name"
            :id="name"
            :value="value"
            :placeholder="placeholder"
            :disabled="disabled"
            @input="$emit('input', $event.target.value)"
        >
    </label>
</template>

<script>
export default {
    props: {
        type: { type: String },
        name: { type: String },
        value: { type: String },
        placeholder: { type: String },
        classes: { type: Object },
        disabled: { type: Boolean },
    },
};
</script>

<style>
</style>